import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'app/app.service';
import { fadeInSlideAnimation } from 'animations';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import * as _ from 'lodash';
import { LoginProvider } from 'providers/login/login';
import { TranslateService } from '@ngx-translate/core';

declare var window;

@Component({
    selector: 'app-ranking',
    templateUrl: './ranking.component.html',
    styleUrls: ['./ranking.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class RankingComponent implements OnInit, OnDestroy {

    ranking: any[] = null;
    userLogOn: string = this.loginProvider.userName;
    isLoading: boolean = false;
    campaignId: string = null;
    selectedTabIndex: Number = 0;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private appService: AppService,
        private domainStorageProvider: DomainStorageProvider,
        public loginProvider: LoginProvider,
        private translateService: TranslateService,
    ) {
        this.showHideMenu(false);
        this.loadRanking();
        this.campaignId = this.route.snapshot.paramMap.get('campaignId');
    }

    async loadRanking() {
        this.isLoading = true;
        await this.domainStorageProvider.rootStore.getUserRanking();
        var ranking = this.domainStorageProvider.rootStore.rankings;

        if (ranking) {
            this.selectedTabIndex = 0;
            ranking.forEach((r, i) => {
                if (r.name && r.name.toLowerCase() == "general") {
                    r.name = this.translateService.instant("RankingPage.GeneralRanking");
                }
                else if (r.id && r.id == this.campaignId) {
                    this.selectedTabIndex = i;
                }
            });
            this.ranking = ranking;

            //track
            this.trackTab(this.selectedTabIndex);
        }

        this.isLoading = false;
    }

    trackTab(selectedIndex:any){
        if(this.ranking && this.ranking[selectedIndex]){
            var url = "/ranking/" + (this.ranking[selectedIndex].shortName).trim();
            this.appService.SetWebTrekkPageView(url);
        }
    }

    onTabChange(event:any){
        //track
        this.trackTab(event.index);
    }

    getUserSpots(rank: any[]): number {
        if (rank != null) {
            let found = rank.find(r => r.logOn == this.userLogOn);
            if (found) {
                return found.score;
            }
        }
        return 0;
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/"]);
    }

}
